import * as Swiper from 'swiper';

import { NgZone, SimpleChanges, KeyValueDiffers } from '@angular/core';
import { Component, Optional, OnInit, DoCheck, OnDestroy, OnChanges } from '@angular/core';
import { Input, Output, ViewChild, HostBinding, EventEmitter, ElementRef, ViewEncapsulation } from '@angular/core';

import { SwiperConfig, SwiperConfigInterface, SwiperEvents } from './swiper.interfaces';


export class SwiperComponent implements OnInit, DoCheck, OnDestroy, OnChanges {
  public swiper: any;

  public isAtLast: boolean;
  public isAtFirst: boolean;

  public showButtons: boolean;
  public showScrollbar: boolean;
  public showPagination: boolean;

  private configDiff: any;
  private childsDiff: number;

  private initialIndex: number;

  
   hidden: boolean = false;
   disabled: boolean = false;

   config: SwiperConfigInterface;

   runInsideAngular: boolean = false;

   indexChange = new EventEmitter<number>();

   s_init                = new EventEmitter<any>();
   s_slideChangeStart    = new EventEmitter<any>();
   s_slideChangeEnd      = new EventEmitter<any>();
   s_slideNextStart      = new EventEmitter<any>();
   s_slideNextEnd        = new EventEmitter<any>();
   s_slidePrevStart      = new EventEmitter<any>();
   s_slidePrevEnd        = new EventEmitter<any>();
   s_transitionStart     = new EventEmitter<any>();
   s_transitionEnd       = new EventEmitter<any>();
   s_touchStart          = new EventEmitter<any>();
   s_touchMove           = new EventEmitter<any>();
   s_touchMoveOpposite   = new EventEmitter<any>();
   s_sliderMove          = new EventEmitter<any>();
   s_touchEnd            = new EventEmitter<any>();
   s_click               = new EventEmitter<any>();
   s_tap                 = new EventEmitter<any>();
   s_doubleTap           = new EventEmitter<any>();
   s_imagesReady         = new EventEmitter<any>();
   s_progress            = new EventEmitter<any>();
   s_reachBeginning      = new EventEmitter<any>();
   s_reachEnd            = new EventEmitter<any>();
   s_destroy             = new EventEmitter<any>();
   s_setTranslate        = new EventEmitter<any>();
   s_setTransition       = new EventEmitter<any>();
   s_autoplay            = new EventEmitter<any>();
   s_autoplayStart       = new EventEmitter<any>();
   s_autoplayStop        = new EventEmitter<any>();
   s_lazyImageLoad       = new EventEmitter<any>();
   s_lazyImageReady      = new EventEmitter<any>();
   s_paginationRendered  = new EventEmitter<any>();
   s_scroll              = new EventEmitter<any>();

   swiperWrapper: ElementRef = null;

    useSwiperClass: boolean = true;

  constructor(private zone: NgZone, private elementRef: ElementRef, private differs: KeyValueDiffers,
     private defaults: SwiperConfig) {}

  ngOnInit() {
    this.showButtons = false;
    this.showScrollbar = false;
    this.showPagination = false;

    let element = this.elementRef.nativeElement;

    let options = new SwiperConfig(this.defaults);

    options.assign(this.config); // Custom config

    if (this.initialIndex != null) {
      options.initialSlide = this.initialIndex;
    }

    if (options.scrollbar === true || options.scrollbar === '.swiper-scrollbar') {
      this.showScrollbar = true;
      options.scrollbar = element.querySelector('.swiper-scrollbar');
    }

    if (options.pagination === true || options.pagination === '.swiper-pagination') {
      this.showPagination = true;

      options.pagination = element.querySelector('.swiper-pagination');
    }

    if (options.prevButton === true || options.prevButton === '.swiper-button-prev') {
      this.showButtons = true;

      options.prevButton = element.querySelector('.swiper-button-prev');
    }
    if (options.nextButton === true || options.nextButton === '.swiper-button-next') {
      this.showButtons = true;

      options.nextButton = element.querySelector('.swiper-button-next');
    }

    if (!options['onSlideChangeStart']) {
      options['onSlideChangeStart'] = (swiper) => {
        this.zone.run(() => {
          this.isAtLast = swiper.isEnd;
          this.isAtFirst = swiper.isBeginning;

          this.indexChange.emit(swiper.snapIndex);
        });
      };
    }

    if (!options['onScrollbarDragEnd']) {
      options['onScrollbarDragEnd'] = (swiper) => {
        this.zone.run(() => {
          this.isAtLast = swiper.isEnd;
          this.isAtFirst = swiper.isBeginning;

          this.indexChange.emit(swiper.snapIndex);
        });
      };
    }

    if (!options['paginationBulletRender']) {
      options['paginationBulletRender'] = (swiper, index, className) => {
        if (this.swiper) {
          if (index === 0) {
            return '<span class="swiper-pagination-handle" index=' + index + '>' +
              '<span class="' + className + ' ' + className + '-first"></span></span>';
          } else if (index === (this.swiper.slides.length - 1)) {
            return '<span class="swiper-pagination-handle" index=' + index + '>' +
              '<span class="' + className + ' ' + className + '-last"></span></span>';
          } else {
            return '<span class="swiper-pagination-handle" index=' + index + '>' +
              '<span class="' + className + ' ' + className + '-middle"></span></span>';
          }
        }
      };
    }

    if (this.runInsideAngular) {
      this.swiper = new Swiper(element.children[0], options);
    } else {
      this.zone.runOutsideAngular(() => {
        this.swiper = new Swiper(element.children[0], options);
      });
    }

    // Add native swiper event handling
    SwiperEvents.forEach((eventName) => {
      let self = this;

      this.swiper.on(eventName, function(event) {
        self[`s_${eventName}`].emit(event);
      });
    });

    if (!this.configDiff) {
      this.configDiff = this.differs.find(this.config || {}).create(null);
    }
  }

  ngDoCheck() {
    let changes = this.configDiff.diff(this.config || {});

    let children = this.swiperWrapper.nativeElement.children.length;

    if (changes) {
      this.initialIndex = this.getIndex();

      changes.forEachAddedItem((changed) => {
        if (changed.key === 'initialSlide') {
          this.initialIndex = this.config.initialSlide;
        }
      });

      this.ngOnDestroy();

      // Timeout is needed for the styles to update properly
      setTimeout(() => {
        this.ngOnInit();

        this.update();
      }, 0);
    } else if (children !== this.childsDiff) {
      this.childsDiff = children;

      this.update();
    }
  }

  ngOnDestroy() {
    if (this.swiper) {
      if (this.runInsideAngular) {
        this.swiper.destroy(true, true);
      } else {
        this.zone.runOutsideAngular(() => {
          this.swiper.destroy(true, true);
        });
      }

      this.swiper = null;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.swiper && changes['hidden'] && this.hidden) {
      // For some reason resize causes Swiper to change index when hidden
      this.initialIndex = this.swiper.activeIndex || 0;
    }

    if (this.swiper && changes['hidden'] && !this.hidden) {
      // For some reason resize causes Swiper to change index when hidden
      this.swiper.activeIndex = this.initialIndex || 0;

      this.update(true);
    }

    if (this.swiper && changes['disabled'] && !this.hidden) {
      if (changes['disabled'].currentValue != changes['disabled'].previousValue) {
        if (changes['disabled'].currentValue === true) {
          if (this.runInsideAngular) {
            this.swiper.lockSwipes();
          } else {
            this.zone.runOutsideAngular(() => {
              this.swiper.lockSwipes();
            });
          }
        } else if (changes['disabled'].currentValue === false) {
          if (this.runInsideAngular) {
            this.swiper.unlockSwipes();
          } else {
            this.zone.runOutsideAngular(() => {
              this.swiper.unlockSwipes();
            });
          }
        }
      }

      this.update(false);
    }
  }

  update(updateTranslate?: boolean) {
    if (this.swiperWrapper) {
      for (let i = 0; i < this.swiperWrapper.nativeElement.children.length; i++) {
        this.swiperWrapper.nativeElement.children[i].classList.add('swiper-slide');
      }
    }

    setTimeout(() => {
      if (this.swiper) {
        if (this.runInsideAngular) {
            this.swiper.update();

            if (updateTranslate) {
              setTimeout(() => {
                if (this.swiper) {
                  this.swiper.update(true);
                }
              }, 0);
            }
        } else {
          this.zone.runOutsideAngular(() => {
            this.swiper.update();

            if (updateTranslate) {
              setTimeout(() => {
                if (this.swiper) {
                  this.swiper.update(true);
                }
              }, 0);
            }
          });
        }

        this.isAtFirst = this.swiper.isBeginning;
        this.isAtLast = this.swiper.isEnd;
      }
    }, 0);
  }

  getIndex() {
    if (!this.swiper) {
      return this.initialIndex;
    } else {
      return this.swiper.activeIndex;
    }
  }

  setIndex(index: number, speed?: number, callbacks?: boolean) {
    if (!this.swiper || this.hidden) {
      this.initialIndex = index;
    } else {
      if (this.runInsideAngular) {
        this.swiper.slideTo(index, speed, callbacks);
      } else {
        this.zone.runOutsideAngular(() => {
          this.swiper.slideTo(index, speed, callbacks);
        });
      }
    }
  }

  prevSlide(callbacks?: boolean, speed?: number) {
    if (this.swiper) {
      if (this.runInsideAngular) {
        this.swiper.slidePrev(callbacks, speed);
      } else {
        this.zone.runOutsideAngular(() => {
          this.swiper.slidePrev(callbacks, speed);
        });
      }
    }
  }

  nextSlide(callbacks?: boolean, speed?: number) {
    if (this.swiper) {
      if (this.runInsideAngular) {
        this.swiper.slideNext(callbacks, speed);
      } else {
        this.zone.runOutsideAngular(() => {
          this.swiper.slideNext(callbacks, speed);
        });
      }
    }
  }

  stopPlay() {
    if (this.swiper) {
      if (this.runInsideAngular) {
        this.swiper.stopAutoplay();
      } else {
        this.zone.runOutsideAngular(() => {
          this.swiper.stopAutoplay();
        });
      }
    }
  }

  startPlay() {
    if (this.swiper) {
      if (this.runInsideAngular) {
        this.swiper.startAutoplay();
      } else {
        this.zone.runOutsideAngular(() => {
          this.swiper.startAutoplay();
        });
      }
    }
  }

  onIndexSelect(event: any) {
    this.setIndex(event.target.attributes.index.value);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'swiper',
  templateUrl: './swiper.component.html',
  styleUrls: ['./swiper.component.css'],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: KeyValueDiffers, },
{type: SwiperConfig, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'hidden': [{ type: HostBinding, args: ['hidden', ] },{ type: Input },],
'disabled': [{ type: Input },],
'config': [{ type: Input },],
'runInsideAngular': [{ type: Input },],
'indexChange': [{ type: Output },],
's_init': [{ type: Output, args: ['init', ] },],
's_slideChangeStart': [{ type: Output, args: ['slideChangeStart', ] },],
's_slideChangeEnd': [{ type: Output, args: ['slideChangeEnd', ] },],
's_slideNextStart': [{ type: Output, args: ['slideNextStart', ] },],
's_slideNextEnd': [{ type: Output, args: ['slideNextEnd', ] },],
's_slidePrevStart': [{ type: Output, args: ['slidePrevStart', ] },],
's_slidePrevEnd': [{ type: Output, args: ['slidePrevEnd', ] },],
's_transitionStart': [{ type: Output, args: ['transitionStart', ] },],
's_transitionEnd': [{ type: Output, args: ['transitionEnd', ] },],
's_touchStart': [{ type: Output, args: ['touchStart', ] },],
's_touchMove': [{ type: Output, args: ['touchMove', ] },],
's_touchMoveOpposite': [{ type: Output, args: ['touchMoveOpposite', ] },],
's_sliderMove': [{ type: Output, args: ['sliderMove', ] },],
's_touchEnd': [{ type: Output, args: ['touchEnd', ] },],
's_click': [{ type: Output, args: ['click', ] },],
's_tap': [{ type: Output, args: ['tap', ] },],
's_doubleTap': [{ type: Output, args: ['doubleTap', ] },],
's_imagesReady': [{ type: Output, args: ['imagesReady', ] },],
's_progress': [{ type: Output, args: ['progress', ] },],
's_reachBeginning': [{ type: Output, args: ['reachBeginning', ] },],
's_reachEnd': [{ type: Output, args: ['reachEnd', ] },],
's_destroy': [{ type: Output, args: ['destroy', ] },],
's_setTranslate': [{ type: Output, args: ['setTranslate', ] },],
's_setTransition': [{ type: Output, args: ['setTransition', ] },],
's_autoplay': [{ type: Output, args: ['autoplay', ] },],
's_autoplayStart': [{ type: Output, args: ['autoplayStart', ] },],
's_autoplayStop': [{ type: Output, args: ['autoplayStop', ] },],
's_lazyImageLoad': [{ type: Output, args: ['lazyImageLoad', ] },],
's_lazyImageReady': [{ type: Output, args: ['lazyImageReady', ] },],
's_paginationRendered': [{ type: Output, args: ['paginationRendered', ] },],
's_scroll': [{ type: Output, args: ['scroll', ] },],
'swiperWrapper': [{ type: ViewChild, args: ['swiperWrapper', ] },],
'useSwiperClass': [{ type: HostBinding, args: ['class.swiper', ] },{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
